import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import lazyLoadRoutes from '../components/LazyLoadRoutes'; 
import TestQandA from '../pages/TestQandA';

const Dashboard = lazyLoadRoutes('ResponseEvaluationsManager');
const ToolSupport = lazyLoadRoutes('ToolSupport');
const ResponseAnalyticsDashboard = lazyLoadRoutes('ResponseAnalyticsDashboard');
const QA = lazyLoadRoutes('TestQandA');

const AppRoutes = () => {
    return (
        <Routes>
            <Route exact path='/' element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route exact path='/Dashboard' element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route exact path='/ResponseAnalyticsDashboard' element={<ProtectedRoute><ResponseAnalyticsDashboard /></ProtectedRoute>} />
            <Route exact path='/Support' element={<ProtectedRoute><ToolSupport /></ProtectedRoute>} />
            <Route exact path='/TestQandA' element={<ProtectedRoute><TestQandA /></ProtectedRoute>} />
        </Routes>
    )
}

export default AppRoutes